import { IEvent } from "../types";

const getEventId = ({id}: IEvent) => id;

export default getEventId;
